import React from "react";
import { Grid2 } from "@mui/material";
import {
  StyledLabelValueRow,
  StyledLabel,
  StyledValue,
  StyledIconWrap,
} from "../AppointmentDetailsModal.styles";

const AppointmentDetailsModalClientInfoField = ({
  icon: Icon,
  label,
  value,
  valueVariant = "body2",
}) => (
  <Grid2 item size={{ xs: 12, sm: 6 }}>
    <StyledLabelValueRow>
      <StyledIconWrap>
        <Icon />
      </StyledIconWrap>
      <StyledLabel variant="caption">{label}</StyledLabel>
    </StyledLabelValueRow>
    <StyledValue variant={valueVariant} bold={valueVariant === "body1"}>
      {value}
    </StyledValue>
  </Grid2>
);

export default AppointmentDetailsModalClientInfoField;
